<div class="table">
    <table mat-table [dataSource]="screenHistory">
        <ng-container matColumnDef="dateMvt">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef>Date </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.dateMvt | date: 'dd/MM/yyyy'}} </td>
        </ng-container>
        
        <ng-container matColumnDef="ut">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> UT </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{ element.utName }} ({{ element.utCode }}) </td>
        </ng-container>

        <ng-container matColumnDef="commentMvt">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Commentaire </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{ element.commentMvt }} </td>
        </ng-container>

        <ng-container matColumnDef="valueBefore">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Valeur Av. </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.valueBefore}} </td>
        </ng-container>

        <ng-container matColumnDef="valueAfter">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Valeur Ap. </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.valueAfter}} </td>
        </ng-container>
        
        <ng-container matColumnDef="hourBefore">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Intitulé Av. </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.hourBefore}} </td>
        </ng-container>

        <ng-container matColumnDef="hourAfter">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Intitulé Ap. </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.hourAfter}} </td>
        </ng-container>

        <ng-container matColumnDef="screenStatusBefore">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Etat Av. </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.screenStatusBefore}} </td>
        </ng-container>

        <ng-container matColumnDef="screenStatusAfter">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Etat Ap. </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.screenStatusAfter}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="custom-header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
